'use client'

import React from 'react'
import Head from './Head'
import { Content } from '@components/Landing/Common'
import HowItWorks from '@components/Landing/HowItWorks'
import WhyWe from '@components/Landing/WhyWe'
import BottomCTA from '@components/Landing/BottomCTA'
import LandingLayout from '@components/Landing/LandingLayout'
import HowToInstall from './HowToInstall'

type Props = {
  platform: string
  gif: string
  helpUrl: string
}

const PlatformLanding = ({ platform, gif, helpUrl }: Props) => {
  return (
    <LandingLayout
      meta={
        <>
          <link
            rel="preload"
            href="https://enhanci-widgets.s3.eu-west-2.amazonaws.com/widgets/widget.c89a1f01-22e4-4859-9ad3-d4435c6abd50.js"
            as="script"
          />
          <link rel="preload" href={gif} as="image" />
        </>
      }
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'WebApplication',
            applicationCategory: 'E-commerce',
            name: `Pricing Table for ${platform}`,
            operatingSystem: 'all',
            screenshot: 'https://enhanci.com/img/landing/compare-new.png',
            creator: {
              '@type': 'Organization',
              url: 'https://enhanci.com/',
              name: 'Enhanci',
              logo: {
                '@type': 'ImageObject',
                url: 'https://enhanci.com/img/logo-black.png',
              },
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.7',
              reviewCount: '98',
            },
            offers: {
              '@type': 'AggregateOffer',
              offeredBy: {
                '@type': 'Organization',
                name: 'Enhanci',
              },
              lowPrice: 0,
              highPrice: 12,
              offerCount: 3,
              priceCurrency: 'USD',
              priceSpecification: [
                {
                  '@type': 'UnitPriceSpecification',
                  price: 0,
                  priceCurrency: 'USD',
                  name: 'Free pricing table',
                },
                {
                  '@type': 'UnitPriceSpecification',
                  price: 8,
                  priceCurrency: 'USD',
                  name: 'Basic pricing table',
                },
                {
                  '@type': 'UnitPriceSpecification',
                  price: 12,
                  priceCurrency: 'USD',
                  name: 'Pro pricing table',
                },
              ],
            },
          }),
        }}
      />
      <Head platform={platform} gif={gif} />
      <Content maxWidth={1200}>
        <HowToInstall platform={platform} helpUrl={helpUrl} />
        <HowItWorks />
        <WhyWe />
        <BottomCTA />
      </Content>
    </LandingLayout>
  )
}

export default PlatformLanding
